<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M12.005 21C16.925 21 21 16.925 21 11.995 21 7.075 16.915 3 11.995 3 7.075 3 3 7.075 3 11.995 3 16.925 7.085 21 12.005 21zm-.01-1.688A7.28 7.28 0 0 1 4.688 12a7.278 7.278 0 0 1 7.298-7.313A7.307 7.307 0 0 1 19.312 12a7.282 7.282 0 0 1-7.317 7.313zM8.991 14.92c.341.341.781.309 1.149-.06l1.798-1.798 1.904 1.904c.36.361.8.407 1.135.072.348-.348.322-.781-.052-1.155l-1.904-1.904 1.904-1.903c.367-.368.4-.808.059-1.15-.341-.34-.788-.288-1.142.067l-1.904 1.903-1.897-1.897c-.367-.367-.814-.407-1.162-.059-.334.335-.275.788.08 1.142l1.896 1.897-1.798 1.799c-.355.354-.407.8-.066 1.142z"
      fill="#0071BB"
      fill-rule="evenodd"
    />
  </svg>
</template>
